import React from 'react';
import classnames from 'classnames';
import * as styles from './styles.module.scss';
import { Link } from 'gatsby';

const CategoryLink = ({ type = 'dark', children, href = '#' }) => (
  <Link to={href} className={classnames(styles.category, styles[type])}>
    <span className={classnames('cr-h5', styles.category_text)}>
      {children}
    </span>
  </Link>
);

export default CategoryLink;
